import { useState } from "react";

interface ListImageWithFallbackProps {
  src?: string;
  alt: string;
  className?: string;
}

export function ListImageWithFallback({
  src,
  alt,
  className,
}: ListImageWithFallbackProps) {
  const [error, setError] = useState(!src);

  const processImageUrl = (
    url: string = "https://placehold.co/400x200?text=Imóvel",
  ) => {
    if (url.includes("resizedimgs.vivareal.com")) {
      const parts = url.split("/");
      const hashIndex = parts.findIndex((part) => part.length === 32);
      if (hashIndex !== -1) {
        const beforeHash = parts.slice(0, hashIndex + 1).join("/");
        const afterHash = parts.slice(hashIndex + 1).join("-");
        return beforeHash + "/" + afterHash;
      }
    }
    return url;
  };

  if (error) {
    return (
      <div
        className={`bg-gray-100 flex items-center justify-center ${className}`}
      >
        <img
          src="/images/placeholder.png"
          alt={"Sem imagem disponível"}
          className="object-cover w-full h-full"
        />
      </div>
    );
  }

  return (
    <div className={`relative ${className}`}>
      <img
        src={processImageUrl(src)}
        alt={alt}
        className={`${className}`}
        onError={() => setError(true)}
        loading="lazy"
        decoding="async"
      />
    </div>
  );
}
